module.exports = __webpack_public_path__ + "1046d7d119dd5eb37b075d85836de332.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/3.00ct.png
// module id = 803
// module chunks = 0